/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Update_ButtonInputs */

const en_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const fr_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour`)
};

const de_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento`)
};

const ru_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлять`)
};

const es_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const zh_cn2_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ja_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデート`)
};

const hi_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अद्यतन`)
};

const pt_pt2_tags_manager_update_button = /** @type {(inputs: Tags_Manager_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Tags_Manager_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_update_button = /** @type {((inputs?: Tags_Manager_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_update_button(inputs)
	if (locale === "de") return de_tags_manager_update_button(inputs)
	if (locale === "it") return it_tags_manager_update_button(inputs)
	if (locale === "ru") return ru_tags_manager_update_button(inputs)
	if (locale === "es") return es_tags_manager_update_button(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_update_button(inputs)
	if (locale === "ja") return ja_tags_manager_update_button(inputs)
	if (locale === "hi") return hi_tags_manager_update_button(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_update_button(inputs)
	return en_tags_manager_update_button(inputs)
});